import { render } from "./BancoModal.vue?vue&type=template&id=237fab31&scoped=true&ts=true"
import script from "./BancoModal.vue?vue&type=script&lang=ts"
export * from "./BancoModal.vue?vue&type=script&lang=ts"

import "./BancoModal.vue?vue&type=style&index=0&id=237fab31&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237fab31"]])

export default __exports__